import { render } from "./BarChartComp.vue?vue&type=template&id=312e26e4"
import script from "./BarChartComp.vue?vue&type=script&lang=js"
export * from "./BarChartComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__